import i18n from 'i18next';

export const scrollbarList = [
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro1'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro2'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro3'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro4'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro5'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro6'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro7'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro8'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro9'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro10'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro11'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro12'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro13'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.introduction.intro14'),
  },
  {
    type: 'subHeading',
    text: i18n.t('clutchTerms.restrictions.heading'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.warn'),
    child: i18n.t('clutchTerms.restrictions.warnCap'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listhead'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing1'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing2'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing3'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing4'),
    child: i18n.t('clutchTerms.restrictions.listing5'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing6'),
    className: 'capitalize',
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing7'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing8'),
    child: i18n.t('clutchTerms.restrictions.listing9'),
  },

  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing10'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing11'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing12'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing13'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing14'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing15'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing16'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing17'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing18'),
  },
  {
    type: 'contentSection',
    text: i18n.t('clutchTerms.restrictions.listing19'),
  },
];
